module.exports = __webpack_public_path__ + "img/step.6ec925b1.png";